export function getInitialStateSiniestro() {
   return {
      formSearch: [],
      polizaDenunciar: [],
      polizas: [],
      lotes: [],
   };
}

export default getInitialStateSiniestro();
